import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { LabelHelper } from '../../helpers/label.helper';
import { AppConfig } from 'src/app/app.config';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { HelpersService } from 'src/app/helpers/helpers.service';
import { CorporateConfig } from 'src/app/corporate.config';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

    isBrowserSupported = true;
    isAccountApplicationMode = AppConfig.getAccountMode;
    @ViewChild('mainContent') mainContent: ElementRef;

    private cmsStyleVariablesUrl: string;

    constructor(
        private authenticationService: AuthenticationService,
        private renderer: Renderer2,
        private helper: HelpersService,
    ) {

        LabelHelper.initialize();
        this.cmsStyleVariablesUrl = this.helper.getPageContent(CorporateConfig.getCmsDomain + CorporateConfig.getCmsStyleVariables);
    }

    ngOnInit() {
        this.isBrowserSupported = this.browserCheck();

        if (this.isAccountApplicationMode) {
            this.loadCmsStyles(this.cmsStyleVariablesUrl);
        }

        this.authenticationService.verifyActiveToken().subscribe({
          next: (res) => this.authenticationService.isUserLoggedin.next(res),
          error: () => this.authenticationService.isUserLoggedin.next(false),
        });
    }

    skipToContent(event: Event) {
        event.preventDefault();
        if (this.mainContent) {
          this.mainContent.nativeElement.focus();

          // Find the first focusable element within main content
          const firstFocusableElement = this.mainContent.nativeElement.querySelector('h1, a[href], button:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"])') as HTMLElement;

          if (firstFocusableElement) {
            firstFocusableElement.focus();
          }
        }
    }

    // currently use to show upload message on IE 11
    private browserCheck(): boolean {
        const ua = window.navigator.userAgent;
        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
             // IE 11 => return version number
            return false;
        }
        return true;
    }

    private loadCmsStyles(url: string) {
        const linkElement = this.renderer.createElement('link');
        this.renderer.setAttribute(linkElement, 'rel', 'stylesheet');
        this.renderer.setAttribute(linkElement, 'href', url);
        this.renderer.appendChild(document.head, linkElement);
    }
}
